
import {menus} from './menu';
import {jquery} from 'jquery'


$(".slick").slick({
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,

})

